import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, filter, map, Observable } from 'rxjs';
import { ErrorHandlerGlobalService } from './error-handler-global.service';
import { ResponseError } from '../../api/v1/models/response-error';
import { ErrorCodes } from '../../api/v1/models/error-codes';

@Injectable()
export class ErrorHandlerInterceptor implements HttpInterceptor {
  constructor(private errorService: ErrorHandlerGlobalService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      filter((event: HttpEvent<any>): event is HttpResponse<any> =>
        event instanceof HttpResponse
      ),
      map((response: HttpResponse<any>) => {
        const body = response.body;

        if (body?.error || !body?.result) {
          throw body;
        }

        return response;
      }),
      catchError((error: HttpErrorResponse | {error: ResponseError}) => {
        if(error instanceof HttpErrorResponse) {
          return this.errorService.handleError('UNKNOWN_ERROR');
        }
        return this.errorService.handleError(error.error.message as ErrorCodes);
      })
    );
  }
}
